import {type Post} from '../../types/posts';
import {type UserProfile} from '../../types/users';
import {General} from '../../constants';

function parseUsernamesFromText(text: string): Array<UserProfile['username']> {
    // defined inline to reset regex state due to "g" flag
    const USERNAME_PATTERN = /\B@(([a-z0-9_.-]*[a-z0-9_])[.-]*)/gim;
    const usernamesSet = new Set<string>();

    let match;

    while ((match = USERNAME_PATTERN.exec(text)) !== null) {
        // match[1] is the matched mention including trailing punctuation
        // match[2] is the matched mention without trailing punctuation
        if (match[2] && General.SPECIAL_MENTIONS.indexOf(match[2]) !== -1) {
            continue;
        }

        // If there's no trailing punctuation, this will only add 1 item to the set
        if (match[1]) {
            usernamesSet.add(match[1].toLowerCase());
        }

        if (match[2]) {
            usernamesSet.add(match[2].toLowerCase());
        }
    }

    return Array.from(usernamesSet);
}

const MAX_CHARACTER_COUNT_TO_PARSE = 4000;
export function parseUsernamesFromPosts(posts: Post[]) {
    const usernamesSet = new Set<string>();

    posts.forEach((post) => {
        const usernamesFromPostMessage = parseUsernamesFromText(post.message);

        usernamesFromPostMessage.forEach((username) => usernamesSet.add(username));

        post.props?.attachments?.forEach(({text, fallback}) => {
            /**
             * Смотрит есть ли текстовое поле
             *
             * Также не парсим его если оно большое
             */
            if (text && text.length <= MAX_CHARACTER_COUNT_TO_PARSE) {
                const usernamesFromAttachmentText = parseUsernamesFromText(text);

                usernamesFromAttachmentText.forEach((username) => usernamesSet.add(username));
                return;
            }

            /**
             * Если текстового поля нет или оно отсуствует - смотрим
             * поле fallback и также не парсим если оно большое
             */
            if (fallback && fallback.length <= MAX_CHARACTER_COUNT_TO_PARSE) {
                const usernamesFromFallback = parseUsernamesFromText(fallback);

                usernamesFromFallback.forEach((username) => usernamesSet.add(username));
            }
        });
    });

    return Array.from(usernamesSet);
}
